module.exports = __webpack_public_path__ + "img/logobnuevo2.8111c807.png";